<template>
  <div id="basket-app">
    <div class="basket">
      <div v-if="step === 0">
        <div class="white_band">
          <h2>panier</h2>
        </div>
        <div class="items">
          <div class="item" v-for="(item, index) in basket" :key="index">
            <div class="item_inner item_book" v-if="item.type === 'book'">
              <figure class="item_thumbnail">
                <div class="square-contain">
                  <div class="inner">
                    <img class="smaller" :src="maybe_fix_pic_url(item.picture)" alt="" />
                  </div>
                </div>
              </figure>
              <div class="item_body">
                <div class="item_info">
                  <figure class="item_micro_thumbnail">
                <div class="square-contain">
                  <div class="inner">
                    <img class="smaller" :src="maybe_fix_pic_url(item.picture)" alt="" />
                  </div>
                </div>
              </figure>
              <div class="item_info_text">
                  <p>
                    <span class="title">{{ item.title }}</span
                    >,
                    <span class="authors">{{
                      item.authors.map((a) => a.fields.name).join(", ")
                    }}</span
                    ><br />
                    <span class="publisher">{{ item.publisher }}</span
                    >,
                    <span class="isbn">ISBN: {{ item.isbn }}</span>
                  </p>
                  </div>
                </div>
                <div class="item_controls">
                  <div class="price">
                    <span>{{ item.price }}€</span>
                  </div>
                  <button
                    class="button_qty"
                    @click="$store.commit('dec_qty', index)"
                  >
                    &minus;
                  </button>
                  <div class="input_qty">
                    <input class="" :value="item.qty" @input="() => 0" />
                  </div>
                  <button
                    class="button_qty"
                    @click="$store.commit('inc_qty', index)"
                  >
                    +
                  </button>
                  <button class="delete" @click="remove_item(index)">
                    Supprimer du panier
                  </button>
                  <a class="shipping" href="/expedition-retours"
                    ><span>Conditions d'expédition</span></a
                  >
                </div>
              </div>
            </div>
            <div class="item_inner item_book" v-if="item.type === 'abo'">
              <figure class="item_thumbnail">
                <div class="square-contain">
                  <div class="inner">
                    <img class="smaller" :src="maybe_fix_pic_url(item.picture)" alt="" />
                  </div>
                </div>
              </figure>
              <div class="item_body">
                <div class="item_info">
                  <figure class="item_micro_thumbnail">
                <div class="square-contain">
                  <div class="inner">
                    <img class="smaller" :src="maybe_fix_pic_url(item.picture)" alt="" />
                  </div>
                </div>
              </figure>
              <div class="item_info_text">
                <p>                  
                    <span class="title">{{ item.title }}</span>
                    </p>
                  </div>
                </div>
                <div class="item_controls">
                  <div class="price">
                    <span>{{ item.price }}€</span>
                  </div>
                  <button
                    class="button_qty"
                    @click="$store.commit('dec_qty_m', index)"
                  >
                    &minus;
                  </button>
                  <div class="input_qty input_qty_abo">
                    <input class="" :value="item.qty + ' mois'" @input="() => 0" />
                  </div>
                  <button
                    class="button_qty"
                    @click="$store.commit('inc_qty_m', index)"
                  >
                    +
                  </button>
                  <button class="delete" @click="remove_item(index)">
                    Supprimer du panier
                  </button>
                  <a class="shipping" href="/expedition-retours"
                    ><span>Conditions d'expédition</span></a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="black_band">
          <div class="total">Total (hors expédition) : {{ total_prom.val }}€</div>
          <div class="promo">
            <div v-if="prom_code" class="prom_code_result">
              <div v-if="valid_prom">{{  total_prom.err }}</div>
              <div v-else>Code promotionnel expiré ou invalide.</div>
            </div>
            <div v-else>Entrez votre code promotionnel</div>
            <label for=""
              ><input type="text"
                style="text-transform: none!important;"
                placeholder="Code promo" v-model="prom_code"
            /></label>
          </div>
        </div>
        <div class="basket_steps solo">
          <div><button @click="step = 1">Mode de livraison &rarr;</button></div>
        </div>
      </div>
      <div v-if="step === 1">
        <div class="white_band">
          <h2>Coordonnées</h2>
        </div>
        <div class="coords_form coords_billing_form">
          <div class="form_side">
            <label class="required"
              ><input
                type="text"
                @input="set('coords_billing', 'last_name', $event.target.value)"
                :value="coords_billing.last_name"
                name="last_name"
                required
                autocomplete
                placeholder="Nom"
              />
            </label>
            <label class="required"
              ><input
                type="text"
                v-model="coords_billing.first_name"
                name="first_name"
                required
                autocomplete
                placeholder="Prénom"
            /></label>
            <label class="required"
              ><input
                type="text"
                @input="set('coords_billing', 'email', $event.target.value)"
                :value="coords_billing.email"
                name="email"
                required
                autocomplete
                placeholder="E-mail"
            /></label>
            <label class="required"
              ><input
                type="text"
                @input="set('coords_billing', 'email_2', $event.target.value)"
                :value="coords_billing.email_2"
                name="email"
                required
                autocomplete
                placeholder="Confirmer l'e-mail"
            /></label>
            <label class="required"
              ><input
                type="phone"
                @input="set('coords_billing', 'phone', $event.target.value)"
                :value="coords_billing.phone"
                name="phone"
                required
                autocomplete
                placeholder="Numéro de téléphone"
            /></label>
          </div>
          <div class="form_side">
            <label class="required"
              ><input
                type="text"
                @input="set('coords_billing', 'address', $event.target.value)"
                :value="coords_billing.address"
                name="address"
                required
                autocomplete
                placeholder="Adresse"
            /></label>
            <label class="required"
              ><input
                type="text"
                @input="
                  set('coords_billing', 'address_comp', $event.target.value)
                "
                :value="coords_billing.address_comp"
                name="address_comp"
                required
                autocomplete
                placeholder="Complément d'adresse (optionnel)"
            /></label>
              <label class="required"
                ><input
                  type="text"
                  @input="
                    set('coords_billing', 'post_code', $event.target.value)
                  "
                  :value="coords_billing.post_code"
                  name="postcode"
                  required
                  autocomplete
                  placeholder="Code postal"
              /></label>
              <label class="required"
                ><input
                  type="text"
                  @input="set('coords_billing', 'city', $event.target.value)"
                  :value="coords_billing.city"
                  name="city"
                  required
                  autocomplete
                  placeholder="Ville"
              /></label>
            <label class="required"
              ><select
                name="country"
                required
                :value="coords_billing.country"
                autocomplete
                @input="set('coords_billing', 'country', $event.target.value)"
              >
                <option v-for="k in countries_fr" :key="k" :value="k">
                  {{ k }}
                </option>
              </select>
            </label>
          </div>
        </div>
        <div class="white_band" v-if="shipping !== 'relay'">
          <label class="checkbox fakebox" for="has_delivery"
            ><input
              type="checkbox"
              v-model="has_delivery"
              id="has_delivery"
            /><span class="box"></span>Ajouter une adresse de livraison (sauf livraison souhaitée en point relais)</label
          >
        </div>
        <div v-if="has_delivery">
          <div class="white_band"><h2>Adresse de livraison</h2></div>
          <div class="coords_form coords_delivery_form">
            <div class="form_side">
              <label
                ><input
                  type="text"
                  @input="
                    set('coords_delivery', 'last_name', $event.target.value)
                  "
                  :value="coords_delivery.last_name"
                  name="last_name"
                  placeholder="Nom"
                />
              </label>
              <label
                ><input
                  type="text"
                  @input="
                    set('coords_delivery', 'first_name', $event.target.value)
                  "
                  :value="coords_delivery.first_name"
                  name="first_name"
                  placeholder="Prénom"
              /></label>
              <label
                ><input
                  type="text"
                  @input="set('coords_delivery', 'phone', $event.target.value)"
                  :value="coords_delivery.phone"
                  name="phone"
                  placeholder="Numéro de téléphone"
              /></label>
              <label
                ><select name="country" v-model="coords_delivery.country">
                  <option v-for="k in countries_fr" :key="k" :value="k">
                    {{ k }}
                  </option>
                </select>
              </label>
            </div>
            <div class="form_side">
              <label
                ><input
                  type="text"
                  @input="
                    set('coords_delivery', 'address', $event.target.value)
                  "
                  name="address"
                  :value="coords_delivery.address"
                  placeholder="Adresse"
              /></label>
              <label
                ><input
                  type="text"
                  @input="
                    set('coords_delivery', 'address_comp', $event.target.value)
                  "
                  name="address_comp"
                  :value="coords_delivery.address_comp"
                  placeholder="Complément d'adresse"
              /></label>
              <label
                ><input
                  type="text"
                  @input="
                    set('coords_delivery', 'post_code', $event.target.value)
                  "
                  name="postcode"
                  :value="coords_delivery.post_code"
                  placeholder="Code postal"
              /></label>
              <label
                ><input
                  type="text"
                  @input="set('coords_delivery', 'city', $event.target.value)"
                  name="city"
                  :value="coords_delivery.city"
                  placeholder="Ville"
              /></label>
            </div>
          </div>
        </div>
        <div class="white_band">
          <h2>Expédition</h2>
        </div>
        <div class="total" v-if="has_items">
          <div>
            <div
              class="shipping_options"
              :class="{ with_boomerang: shipping !== 'local' }"
            >
              <label class="fakeradio" for="shipping-local"
                ><input
                  type="radio"
                  id="shipping-local"
                  name="shipping"
                  v-model="shipping"
                  value="local"
                /><span class="radio"></span> Click&Collect <strong>en Gironde</strong><br><a href="/clicandcollect" style="color:black">(+ d'infos)</a> 0€</label
              >
              <label
                class="fakeradio"
                :class="{ disabled: destination_country !== 'France' }"
                for="shipping-relay"
                ><input
                  type="radio"
                  name="shipping"
                  v-model="shipping"
                  value="relay"
                  id="shipping-relay"
                /><span class="radio"></span>Mondial Relay (France)
                {{ relay_shipping }}€</label
              >
              <label class="fakeradio" for="shipping-colis"
                ><input
                  id="shipping-colis"
                  type="radio"
                  name="shipping"
                  v-model="shipping"
                  value="standard"
                /><span class="radio"></span> Colissimo à domicile
                {{ colissimo_shipping }}€</label
              >
              <label
                :class="{ disabled: shipping === 'local' }"
                for="shipping-boomerang"
                class="fakebox"
                ><input
                  type="checkbox"
                  id="shipping-boomerang"
                  v-model="shipping_boomerang"
                />
                <span class="box"></span>Colis Boomerang
                (+2€)</label
              >
            </div>
            <div v-if="shipping === 'relay'">
              <div class="white_band">
                <h2 v-if="!mondial_relay_AP">Choix du point relais</h2>
                <h2 v-else>
                  Point relais choisi : {{ this.mondial_relay_AP.Nom }} /
                  {{ this.mondial_relay_AP.Ville }}
                </h2>
              </div>
              <div>
                <div id="relay-target-wrap"></div>
              </div>
            </div>
            <div class="basket_steps">
              <div><button @click="step = 0">&larr; Retour au panier</button></div>
              <div>
                <button :class="{disabled: !is_valid}" @click="step = 2">Mode de paiement &rarr;</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="step === 2">
            <div class="white_band">
              <h2>PAIEMENT</h2>
            </div>
            <div class="payment-buttons">
              <button @click="pay({ online_payment: true })" :class="{ disabled: loading }">
                Payer {{ n(total_prom.val) + n(shipping_cost) }}€ par carte bancaire
                <span class="payment-info">Paiement sécurisé par Stripe</span>
              </button>
              <button @click="pay({ online_payment: false })" :class="{ disabled: loading || shipping !== 'local' }">
                Payer {{ total_prom.val }}€ au local
              </button>
            </div>
            <div class="basket_steps solo">
              <div @click="step = 1"><button>&larr; Retour au mode de livraison</button></div>
            </div>
          </div>
    </div>
    <a href="" style="display: block; margin:1em 8px; text-align:left;color: black;cursor:pointer; text-decoration: none;" @click.prevent="reset_basket">vider le panier</a>
  </div>
</template>

<script>
import countries from "i18n-iso-countries";
import fr from "i18n-iso-countries/langs/fr.json";
import axios from "axios";

countries.registerLocale(fr);
const find_slot = (slots, amount) => {
  // eslint-disable-next-line
  return slots.find(([a, b]) => amount < b)[0];
};

const n = (a) => Number(a.toString());
const ZONE_1 = [
  "Suisse",
  "Royaume-Uni",
  "Allemagne",
  "Autriche",
  "Belgique",
  "Bulgarie",
  "Chypre",
  "Croatie",
  "Danemark",
  "Espagne",
  "Estonie",
  "Finlande",
  "France",
  "Grèce",
  "Hongrie",
  "Irlande",
  "Italie",
  "Lettonie",
  "Lituanie",
  "Luxembourg",
  "Malte",
  "Pays-Bas",
  "Pologne",
  "Portugal",
  "République tchèque",
  "Roumanie",
  "Slovaquie",
  "Slovénie",
  "Suède"
];

const remap_to_legacy_method = (methods, key) => {
  const c = methods.find(m => m.slug === key);
  if (!c) return [];
  return c.rates.map(r => {
    return [r.price / 100, r.max_weight];
  }).concat([[c.max_weight_price / 100, 99999]]);
};

export default {
  name: "Basket",
  data() {
    return {
      step: 0,
      loading: 0,
      opts: {
        fixed_shipping: false,
        shipping_methods: window.basket.shipping_methods,
        shipping_zones: window.basket.shipping_zones,
        shipping_thresholds_colissimo_france: remap_to_legacy_method(window.basket.shipping_methods, 'colissimo-france'),
        shipping_thresholds_colissimo_zone1: remap_to_legacy_method(window.basket.shipping_methods, 'colissimo-europe'),
        shipping_thresholds_colissimo_zone2: remap_to_legacy_method(window.basket.shipping_methods, 'colissimo-monde'),
        shipping_thresholds_colissimo_mondial_relay_fr: remap_to_legacy_method(window.basket.shipping_methods, 'mondialrelay-france'),
        prom_codes: [],
      },
    };
  },
  computed: {
    is_valid() {
      const c = this.coords_billing;
      return c.email
        && (c.email.indexOf('@') !== -1)
        && (c.email === c.email_2)
        && (c.city)
        && (c.post_code)
        && (c.first_name && c.last_name)
        && (c.address)
    },
    countries_fr() {
      const l = countries.getNames("fr");
      const d = Object.values(l);
      d.sort();
      return d;
    },
    basket() {
      return this.$store.state.items;
    },
    coords_delivery() {
      return this.$store.state.coords_delivery;
    },
    coords_billing() {
      return this.$store.state.coords_billing;
    },
    destination_country() {
      if (this.has_delivery) {
        return this.coords_delivery.country;
      }
      return this.coords_billing.country;
    },
    shipping: {
      get() {
        return this.$store.state.shipping;
      },
      set(v) {
        this.set("shipping", v);
      },
    },
    has_delivery: {
      get() {
        return this.$store.state.has_delivery;
      },
      set(v) {
        this.set("has_delivery", v);
      },
    },
    prom_code: {
      get() {
        return this.$store.state.prom_code;
      },
      set(v) {
        axios.post('/checkout/promocode', {code: v}).then(r => {
          this.$set(this.opts, 'prom_codes', [r.data]);
          this.set("prom_code", v);
        }).catch(e => {
          this.set("prom_code", v);
        });
      },
    },
    mondial_relay_AP: {
      get() {
        return this.$store.state.mondial_relay_AP;
      },
      set(v) {
        this.set("mondial_relay_AP", v);
      },
    },
    shipping_boomerang: {
      get() {
        return this.$store.state.shipping_boomerang;
      },
      set(v) {
        this.set("shipping_boomerang", v);
      },
    },
    has_items() {
      return this.basket.length > 0;
    },
    total() {
      return this.basket.reduce((out, item) => {
        let cost = n(item.qty) * n(item.price);
        return out + cost;
      }, 0);
    },
    total_prom() {
      if (!this.valid_prom) return {
        val: this.total,
        err: '',
      };
      if (this.total < this.valid_prom.min_amount) return {
        val: this.total,
        err: `Ce code promo n'est applicable qu'à partir de ${this.valid_prom.min_amount}€`,
      };
      if (this.valid_prom.type === "percent") {
        return {
          val: (this.total * (1 - n(this.valid_prom.amount) / 100)).toFixed(2),
          err: `Réduction de ${this.valid_prom.amount}% appliquée`
        };
      }
      if (this.valid_prom.type === "absolute") {
        if ((this.total * 100) < this.valid_prom.amount) return {
          val: this.total,
          err: `Votre commande a un montant plus faible que la valeur de ce code promo.`,
        };
        return {
          val: (this.total - (this.valid_prom.amount / 100)),
          err: `Réduction de ${(this.valid_prom.amount / 100).toFixed(2)}€ appliquée.`,
        };
      }
      if (this.valid_prom.type === `shipping`) {
        return {
          val: this.total,
          err: `Frais de port à ${(this.valid_prom.amount/100).toFixed(2)}€ appliqués !`
        }
      }
      return {
        val: this.total,
        err: ``,
      };
    },
    weight() {
      return this.basket.reduce((out, item) => {
        let weight = n(item.weight) * n(item.qty);
        if (item.type === "abo") {
          weight = 0;
        }
        return out + weight;
      }, 0);
    },
    shipping_cost() {
      const carry = this.shipping_boomerang ? 2 : 0;
      if (this.valid_prom && this.valid_prom.type === 'shipping' && this.total > this.valid_prom.min_amount) {
        return carry + (this.valid_prom.amount / 100);
      }
      if (this.shipping === "local") return 0;
      if (this.weight === 0) return 1 + carry;
      if (this.shipping === "standard")
        return this.colissimo_shipping + carry;
      if (this.shipping === "relay")
        return this.relay_shipping + carry;
      return 0;
    },
    relay_shipping() {
      if (this.weight === 0) return 1;
      if (this.valid_prom && this.valid_prom.type === 'shipping' && this.total > this.valid_prom.min_amount) {
        return (this.valid_prom.amount / 100);
      }
      return find_slot(
        this.opts.shipping_thresholds_colissimo_mondial_relay_fr,
        this.weight
      );
    },
    colissimo_shipping() {
      if (this.weight === 0) return 1;
      if (this.valid_prom && this.valid_prom.type === 'shipping' && this.total > this.valid_prom.min_amount) {
        return (this.valid_prom.amount / 100);
      }
      let slots = [];
      if (this.destination_country === "France") {
        slots = this.opts.shipping_thresholds_colissimo_france;
      } else if (ZONE_1.find((a) => a === this.destination_country)) {
        slots = this.opts.shipping_thresholds_colissimo_zone1;
      } else {
        slots = this.opts.shipping_thresholds_colissimo_zone2;
      }
      return find_slot(slots, this.weight);
    },
    valid_prom() {
      // eslint-disable-next-line
      const c = this.opts.prom_codes.find(c => c.code === this.prom_code);
      return c || false;
    }
  },
  watch: {
    shipping(val, old) {
      if (val === "local") {
        this.set("shipping_boomerang", 0);
      }
      if (val === "relay") {
        this.has_delivery = false;
        this.$nextTick(() => {
          this.activate_mr();
        });
      } else if (old === "relay") {
        this.$nextTick(() => {
          this.destroy_mr();
        });
      }
    },
    destination_country(val) {
      if (val !== "France") {
        if (this.shipping === "relay") {
          this.shipping = "standard";
        }
      }
    },
  },
  components: {},
  methods: {
    reset_basket() {
      window.publish('RESET_BASKET');
      window.location.href = '/';
    },
    activate_mr() {
      const d = this.$el.querySelector("#relay-target-wrap");
      if (!d) return;
      const t = document.createElement("div");
      d.appendChild(t);
      $(t).MR_ParcelShopPicker({
        Brand: "CC223H2T",
        Country: "FR",
        Responsive: true,
        ShowResultsOnMap: true,
        OnParcelShopSelected: (e) => {
          this.$set(this, "mondial_relay_AP", e);
        },
      });
    },
    destroy_mr() {
      const d = this.$el.querySelector("#relay-target-wrap");
      if (!d) return;
      d.innerHTML = "";
      this.$set(this, "mondial_relay_AP", null);
    },
    n,
    remove_item(index) {
      this.$store.commit("remove_item", index);
    },
    set(...args) {
      this.$store.commit("set", args);
    },
    pay(params) {
      if (this.loading) return;
      this.loading = true;
      axios
        .post("/checkout", { payload: { ...params, ...this.$store.state } })
        .then((response) => {
          if (response.data && response.data.type === 'online_payment' && response.data.url) {
            window.location.href = response.data.url;
          } else if (response.data && response.data.type === 'local_payment') {
            window.location.href = '/merci-local';
          } else {
            this.loading = false;
          }
        }).catch(() => {
          this.loading = false;
        });
    },
    maybe_fix_pic_url(str)
    {
      if (!str) return str;
      if (str.indexOf('epagine') !== -1) return str;
      if (str.indexOf('http') !== -1) return str;
      return window._abelujo_url_ + str;
    },
  },
};
</script>
